export const API_TYPE_OPTIONS = {
    seller: {
        value: 'seller',
        label: 'Seller'
    },
    vendor: {
        value: 'vendor',
        label: 'Vendor'
    }
}